import { Component, EventEmitter, OnInit } from "@angular/core";
import { StsNotification } from "../../../models/sts-notification.model";
import { StsA360RegServicesService } from "../../../services/sts-a360-reg-services.service";
import StsA360RegStep2UsernamePostModel from "../../../models/sts-a360-reg-step2-username-post.model";
import { StsTenantService } from "../../../services/sts-tenant.service";
import { StsPortalStatusService } from "../../../services/sts-portal-status.service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { StsNotificationType } from "../../../models/sts-notification-type";
import { __usernameOrEmail } from "../../../directives/validators/sts-conditional-email-validator.directive";
import { StsPortalStatus } from "../../../models/sts-portal-status";
import { StsTenant } from "../../../models/sts-tenant.model";
import { StsTfaRegServiceService } from "../../../services/sts-tfa-reg-service.service";
import { StsCmsService } from "../../../services/sts-cms-service.service";
import StsA360NotificationTokenModel from "app/models/sts-a360-notification-token.model";
import * as ph from "libphonenumber-js";
import { StsUserService } from "app/services/sts-user.service";
import { StsRegexBluePrintModel } from "app/models/sts-regex-blue-print.model";
import { StsUser } from "app/models/sts-user.model";

@Component({
  selector: "app-account-reg-validate-mobile-number",
  templateUrl: "./account-reg-validate-mobile-number.component.html",
  styleUrls: ["./account-reg-validate-mobile-number.component.scss"],
})
export class AccountRegValidateMobileNumberComponent implements OnInit {
  public model: StsA360RegStep2UsernamePostModel =
    new StsA360RegStep2UsernamePostModel();
  public errors: StsNotification[] = [];
  public signUpForm: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public mobileIsValid = true; 
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public changeUserId: boolean = false;

  message: StsA360NotificationTokenModel;
  constructor(
    private tfa: StsTfaRegServiceService,
    private regService: StsA360RegServicesService,
    private userService: StsUserService,
    private portalStatusService: StsPortalStatusService,
    private route: ActivatedRoute,
    private tenantService: StsTenantService,
    public fb: FormBuilder,
    private tntInfo: StsTenantService,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      this.changeUserId = params["changeUserId"] === "true";

      this.tenantService.getTenantSource().subscribe((tenant) => {
        this.tenantInfo = tenant;

        this.portalStatusService
          .getPortalStatus()
          .subscribe((portalStatus: StsPortalStatus) => {
            let isSelfRegFlow = portalStatus.isSelfRegFlow;

            this.model = new StsA360RegStep2UsernamePostModel();
            this.model.id = params["id"];

            if (this.message.Phone) {
              let fc = this.signUpForm.controls["mobileInput"] as FormControl;
              fc.setValue(this.message.Phone);
            }
          });
      });

      this.signUpForm = this.fb.group({
        mobileInput: new FormControl("", {
          validators: [
            (c: FormControl) => {
              if (!c.value) {
                return {
                  mobileRequired: {
                    valid: false,
                  },
                };
              }
              let re = atob(this.tenantInfo.usefulPatterns["phone"] + "");
              re = re.replace(/(^\\A)|(\\Z$)/g, "");
              this.mobileIsValid = new RegExp(re).test(c.value);
              return new RegExp(re).test(c.value)
                ? null
                : {
                    validateMobile: {
                      valid: false,
                    },
                  };
            },
          ],

          updateOn: "submit",
        }),
      });

      // this.resetFields();
    });
  }

  ngOnInit() {
    this.regService.currentMessage.subscribe(
      (message) => (this.message = message)
    );
  }

  public triggerValidation(v) {
    this.signUpForm.controls["mobileInput"].updateValueAndValidity();
  }

  public resetFields() {
    this.signUpForm.controls["mobileInput"].reset();
  }

  public gotoHome(): void {
    this.router.navigateByUrl("/");
  }

  onSubmit(): void {
    this.submitter.emit(false);
    this.triggerValidation("");
    if (this.signUpForm.valid) {
      this.submitter.emit(true);
      this.errors = [];
      let n = new StsA360RegStep2UsernamePostModel();
      n.id = this.model.id;
      let user = new StsUser();
      user.id = n.id;
      n.mobilePhone = this.signUpForm.controls["mobileInput"].value;
      if (this.changeUserId) {
        // update user in ariel security db
        if (n.email) user.hasEmailChanged = true;

        user.userName = n.email;
        this.userService.changeUserId(user).subscribe((data) => {
          let url = "/account/forgot-username/";
          this.router.navigate([
            url,
            { newUserName: user.userName, userId: user.id },
          ]);
        });
      }
       else {
        // register a new user in ariel360
        this.regService.postStep2Answers(n).subscribe((rs) => {
          this.submitter.emit(false);
          if (rs.success) {
            this.tfa.setEmailAsVerified(n.email).subscribe((a) => {
              if (a.success) {
                let url = "/account/password/new";
                this.router.navigate([url, { id: user.id }]);
              } else {
                let e = new StsNotification();
                e.code = rs["sts-code"] || rs.stsCode;
                e.level = StsNotificationType.Error;
                e.description = "Failed registering the mobile";
                this.errors = [e];
              }
            });
          } else {
            let e = new StsNotification();
            e.code = rs["sts-code"] || rs.stsCode;
            e.level = StsNotificationType.Error;
            e.description = "submitted data contains errors";
            this.errors = [e];
          }
        });
      }
    } else {
      let e = new StsNotification();
      e.code = "sts-correct-username-errors";
      e.level = StsNotificationType.Error;
      e.description = "submitted data contains errors";
      this.errors = [e];
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getReType(re: string): StsRegexBluePrintModel {
    let tmp = new StsRegexBluePrintModel();
    re = re.replace(/(^\\A)|(\\Z$)/g, "");
    tmp.regexp = new RegExp(btoa(re));
    tmp.model = this.model;
    return tmp;
  }
}
